/**
 * @file server.config.js
 * @description 
 * This file will ensure the production environment is used when 
 * building the app, and the development environment is used when running the dev server.
 * @exports Object development or production environment
 */

/**
 * @constant
 * dev environment
 */ 
const apiBaseUrl = window.location.host.includes("127.0.0.1") ?  "https://portaldan.qumulex.dev" : window.location.protocol + "//" + window.location.host;
const dev = {
  apiBaseUrl: apiBaseUrl,
  hsPortalId: '5967232',
  
  // Dev Portal's Firebase configuration
  // Manage this project at https://console.firebase.google.com, drittman@qumulex.com
  //https://firebase.google.com/docs/web/setup?authuser=0
  firebaseConfig: {
    apiKey: "AIzaSyAWwxtwpypNY7JDN0GhftcVZKnT5t8jX6s",
    authDomain: "testportal-9908b.firebaseapp.com",
    databaseURL: "https://testportal-9908b.firebaseio.com",
    projectId: "testportal-9908b",
    storageBucket: "testportal-9908b.appspot.com",
    messagingSenderId: "485500732047",
    appId: "1:485500732047:web:4bcb8fafd5def180"
  }
}

/**
 * @constant
 * production environment
 */ 
const apiBaseUrlP = window.location.host.includes("127.0.0.1") ?  "https://portal.qumulex.io" : window.location.protocol + "//" + window.location.host;
const prod = {
  apiBaseUrl: apiBaseUrlP,
  hsPortalId: '4819185',

  // Production Portal's Firebase configuration
  firebaseConfig: {
    apiKey: "AIzaSyA4Ka824GQsMygo1J3IMkXylGSvuoK64jA",
    authDomain: "qx-portal-production.firebaseapp.com",
    databaseURL: "https://qx-portal-production.firebaseio.com",
    projectId: "qx-portal-production",
    storageBucket: "qx-portal-production.appspot.com",
    messagingSenderId: "661089138133",
    appId: "1:661089138133:web:aa00d76155d18befd9795c",
    measurementId: "G-BSSNL2KW9V"
  }
}

/**
 * @exports Object node environment
 * @example
 * if node environment === "development", exports dev environment,
 * if node environment === "production", exports prod environment
 */
export default process.env.NODE_ENV === 'development' 
  ? dev 
  : prod